import type { ReactElement } from 'react'
import { SignupShareThemeProvider } from '../styles/signupShareTheme'

export function wrapInstrumentInfoGuestTheme(
  userGuest: boolean,
  node: ReactElement,
): ReactElement {
  if (!userGuest) {
    return node
  }
  return <SignupShareThemeProvider>{node}</SignupShareThemeProvider>
}
